import React, { PropTypes, Component } from "react";
import {
  NitroHeading,
  NitroPanel,
  NitroDivider,
  NitroToggle,
  NitroCheckbox,
  NitroText
} from "nitro-components";
import styled from "styled-components";

import { media } from "style-utils";

import { formatContent } from "../helper";

import EditPortalSettings from "./EditPortalSettings";

import { EDIT_LABEL } from "../content";

const CheckboxWrapper = styled.section`
  display: inline-block;
`;

const ToggleContainer = styled.section`
  cursor: pointer;
  position: relative;
  overflow: visible;
  display: table;
  height: auto;
  width: auto;
`;

const HeadingContainer = styled.section`
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
`;
const SettingItemContainer = styled.section`
  opacity: ${props => (props.disabled ? 0.5 : 1)};

`;

const Settings = styled.div`
  padding: 10px 30px;
  width: 100%;
  display: flex;
  justify-content: space-between;

  ${media.mobileTablet`
    padding: 0px;
  `}
`;

const PanelContent = styled.div`
  padding: 30px 40px;

  ${media.mobileTablet`
    padding: 20px 20px 1px 20px;
  `}
`;

const EditContainer = styled.section`
  display: flex;
  text-align: right;
  flex-direction: row;
`;

const Edit = styled.div`
    text-decoration: none;
    cursor: pointer;
    display: inline-block;
    margin-left: 20px;
    pointer-events: ${props => (props.disabled ? "none" : "inherit")};
    cursor:  ${props => (props.disabled ? "default" : "pointer")};
`;

const Hint = styled.div`
  width: 460px;
`;

const HintContainer = styled.section`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;

  ${media.mobileTablet`
    display: none;
  `}
`;

class PortalNotificationSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disableFields: false,
      showEditPanel: false,
      contentKey: "",
      categoryId: "",
      parameters: [],
      categoryTitle: ""
    };
  }

  // On toggle of categories
  onToggle = (id, checked) => {
    const payloadData = {};
    const data = {
      ContentKey: id,
      Enabled: checked
    };
    payloadData.NotificationContentSettings = [];
    payloadData.NotificationContentSettings.push(data);
    this.savePortalInfo(payloadData);
  };

  toggleEditPanel = (enabled, contentKey, option, index) => {
    if (enabled) {
      this.setState({
        showEditPanel: true,
        categoryId: option.CategoryId,
        categoryTitle: option.Description,
        contentKey: contentKey,
        parameters: option.Parameters
      });
    }
  };

  cancelEdit = () => {
    this.setState({
      showEditPanel: false
    });
  };

  setValue = () => {};

  // On check/uncheck of parameters
  selectParam = (key, option) => {
    let payloadData = {};
    payloadData = {
      NotificationContentSettings: [
        {
          ContentKey: key,
          NotificationSettings: [
            {
              CategoryId: option.CategoryId,
              Enabled: !option.Enabled
            }
          ]
        }
      ]
    };
    this.savePortalInfo(payloadData);
  };

  closeEditPanel = () => {
    this.setState({
      showEditPanel: !this.state.showEditPanel
    });
  };

  // On save edit portal settings
  saveSettings = parameters => {
    const editData = this.state;
    let payloadData = {};
    payloadData = {
      NotificationContentSettings: [
        {
          ContentKey: editData.contentKey,
          NotificationSettings: [
            {
              CategoryId: editData.categoryId,
              Parameters: parameters
            }
          ]
        }
      ]
    };
    this.savePortalInfo(payloadData);
    this.closeEditPanel();
  };

  savePortalInfo(payload) {
    this.props.savePortalEditInfo(payload);
  }

  render() {
    const { data } = this.props;
    const contentKey = data.ContentKey;
    return (
      <div>
        <NitroPanel padding="0px" marginBottom="10px" boxShadowLight>
          <PanelContent>
            <HeadingContainer>
              <NitroHeading
                label={data.Heading}
                size="3"
                variant="secondary"
                inline
              />
              <ToggleContainer>
                <NitroToggle
                  activeLabel="ON"
                  label="OFF"
                  toggled={data.Enabled}
                  variant="primary"
                  action={(event, checked) =>
                    this.onToggle(data.ContentKey, checked)}
                />
              </ToggleContainer>
            </HeadingContainer>

            {data.NotificationSettings &&
              data.NotificationSettings.map((option, index) => {
                return (
                  <SettingItemContainer key={index} disabled={!data.Enabled}>
                    <Settings>
                      <CheckboxWrapper>
                        <NitroCheckbox
                          label={option.Description}
                          action={() => this.selectParam(contentKey, option)}
                          variant="secondary"
                          labelVariant="base1"
                          isControlled={false}
                          defaultChecked={option.Enabled}
                          disabled={!data.Enabled}
                        />
                      </CheckboxWrapper>
                      {option.Parameters &&
                        <EditContainer disabled={!data.Enabled}>
                        <Hint>
                          <HintContainer>
                            {option.Parameters.map((item, index) => {
                              return (
                                <span key={index}>
                                  <NitroText size="3" variant="base3">
                                    {item.HintText}
                                    {" "}

                                  </NitroText>
                                  <NitroText size="3" variant="base3" bold>
                                    {formatContent(
                                      item.Value,
                                      item.Unit,
                                      item.DataType
                                    )}
                                  </NitroText>
                                </span>
                              );
                            })}
                          </HintContainer>
                          </Hint>
                          <Edit
                            disabled={!data.Enabled || !option.Enabled}
                            onClick={() =>
                              this.toggleEditPanel(
                                data.Enabled,
                                contentKey,
                                option,
                                index
                              )}
                          >
                            <NitroText size="4" variant={option.Enabled ? "secondary" : "base3"} bold>
                              {EDIT_LABEL}
                            </NitroText>
                          </Edit>
                        </EditContainer>}
                    </Settings>
                    <NitroDivider />
                  </SettingItemContainer>
                );
              })}
          </PanelContent>
        </NitroPanel>

        <EditPortalSettings
          isOpen={this.state.showEditPanel}
          onCancel={this.cancelEdit}
          onSave={this.saveSettings}
          title={this.state.categoryTitle}
          editDetails={this.state.parameters}
        />

      </div>
    );
  }
}

PortalNotificationSetting.propTypes = {
  data: PropTypes.object,
  savePortalEditInfo: PropTypes.func
};

export default PortalNotificationSetting;



// WEBPACK FOOTER //
// ./src/features/notification/notification-settings/components/PortalNotificationSetting.js